<script setup lang="ts">
import { RouterLink } from 'hybridly/vue';

import AngleRight from '@/icons/line/angle-right.svg';
import ArrowUpRight from '@/icons/line/arrow-up-right.svg';
import Avatar from '@/components/studentParentApp/avatar/Avatar.vue';

type RouterLinkOptions = ExtractPropTypes<typeof RouterLink>['options'];

type CardListItemProps = {
  href?: string;
  hrefOptions?: RouterLinkOptions;
  isExternalLink?: boolean;
  user:
    | App.Auth.Data.UserData
    | App.Auth.Data.StudentUserData
    | App.Students.Data.StudentParentData;
};

const props = defineProps<CardListItemProps>();

const computedLinkComponent = computed(() => {
  if (props.isExternalLink && props.href) {
    return 'a';
  }
  return props.href ? RouterLink : 'div';
});
</script>

<template>
  <li>
    <component
      :is="computedLinkComponent"
      :href="href"
      :options="hrefOptions"
      class="flex shrink-0 items-center justify-between gap-x-2.5 px-4 py-3.5"
      :class="{
        'ring-inset hover:bg-slate-50 focus:outline-none focus:ring-3 focus:ring-primary-300 active:bg-slate-100':
          href
      }"
    >
      <div class="flex grow items-center gap-x-3.5">
        <Avatar :user="user" size="sm" />
        <div class="flex flex-col">
          <p class="text-base font-medium leading-5 text-slate-900">{{ user.name }}</p>
        </div>
      </div>
      <div class="flex items-center justify-between gap-x-2 text-slate-900">
        <ArrowUpRight v-if="isExternalLink && href" class="h-6 w-6 text-slate-400" />
        <AngleRight v-else-if="href" class="h-6 w-6 text-slate-400" />
      </div>
    </component>
  </li>
</template>
